import { render, staticRenderFns } from "./FFDetail.vue?vue&type=template&id=172bf2e4"
import script from "./FFDetail.vue?vue&type=script&lang=js"
export * from "./FFDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports